import { Link, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

function PublicLayout() {
  const { t } = useTranslation('landing');
  return (
    <div className="public-shell">
      <header className="public-topbar">
        <Link to="/" className="public-brand">Zlux</Link>
        <nav className="public-topbar-actions">
          <LanguageSwitcher />
          <Link to="/how-to-use" className="text-btn">{t('publicNav.howItWorks')}</Link>
          <Link to="/login" className="text-btn">{t('publicNav.login')}</Link>
          <Link to="/signup" className="primary-btn">{t('publicNav.signup')}</Link>
        </nav>
      </header>
      <main className="public-content">
        <Outlet />
      </main>
    </div>
  );
}

export default PublicLayout;
